import { t } from '@lingui/core/macro';
import { VStack } from '@chakra-ui/react';

import { djs } from '@duke-hq/djs';
import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

import buildLinkToEnrolments from '../../utils/buildLinkToEnrolments';
import ContentContainer from './shared/ContentContainer';
import ProgressBarCard from './shared/ProgressBarCard';
import PieFiftyToSeventyFive from './icons/PieFiftyToSeventyFive';
import PieZeroToTwentyFive from './icons/PieZeroToTwentyFive';
import PieTwentyFiveToFifty from './icons/PieTwentyFiveToFifty';
import PieSeventyFivePlus from './icons/PieSeventyFivePlus';
import SidePanelContentHeader from './shared/ContentHeader';
import NoDataMessage from './shared/NoDataMessage';

function EngagementWithData() {
  const { filters } = useFiltersContext();
  const { data } = trpcTenant.dashboard.getEngagement.useQuery({ filters }, { suspense: true });

  if (data === undefined) {
    return <NoDataMessage />;
  }

  const { thisWeek, lastWeek, twoWeeksOneMonth, overOneMonth } = data;

  const icons = [
    <PieZeroToTwentyFive key={0} />,
    <PieTwentyFiveToFifty key={1} />,
    <PieFiftyToSeventyFive key={2} />,
    <PieSeventyFivePlus key={3} />,
  ];

  return (
    <>
      <SidePanelContentHeader
        title={t`Semester Progress`}
        tooltipText={t`Semester progress broken down in to last activity`}
      />

      <VStack spacing={2} align="flex-start">
        <ProgressBarCard
          title={t`30+ Days since last activity`}
          total={overOneMonth.total}
          data={overOneMonth.data}
          icons={icons}
          to={buildLinkToEnrolments({
            lastActivityEnd: djs.utc().subtract(31, 'days'),
          })}
        />
        <ProgressBarCard
          title={t`15-30 Days since last activity`}
          total={twoWeeksOneMonth.total}
          data={twoWeeksOneMonth.data}
          icons={icons}
          to={buildLinkToEnrolments({
            lastActivityStart: djs.utc().subtract(30, 'days'),
            lastActivityEnd: djs.utc().subtract(15, 'days'),
          })}
        />
        <ProgressBarCard
          title={t`8-14 Days since last activity`}
          total={lastWeek.total}
          data={lastWeek.data}
          icons={icons}
          to={buildLinkToEnrolments({
            lastActivityStart: djs.utc().subtract(14, 'days'),
            lastActivityEnd: djs.utc().subtract(8, 'days'),
          })}
        />
        <ProgressBarCard
          title={t`Activity this week`}
          total={thisWeek.total}
          data={thisWeek.data}
          icons={icons}
          to={buildLinkToEnrolments({
            lastActivityStart: djs.utc().subtract(7, 'days'),
            lastActivityEnd: djs.utc(),
          })}
        />
      </VStack>
    </>
  );
}

export default function Engagement() {
  return (
    <ContentContainer title={t`Last activity`}>
      <EngagementWithData />
    </ContentContainer>
  );
}
